import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var CocktailIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsxs("svg", {
                    viewBox: "0 0 24 24",
                    children: [
                        _jsx("path", {
                            d: "M11.148 2a1.1 1.1 0 101.905 1.1A1.1 1.1 0 0011.148 2zM3.148 3a1.1 1.1 0 101.905 1.1A1.1 1.1 0 003.148 3zM11.55 8.503a1.1 1.1 0 111.1-1.905 1.1 1.1 0 01-1.1 1.905zM2.148 10a1.1 1.1 0 101.905 1.1A1.1 1.1 0 002.148 10zM2.55 15.503a1.1 1.1 0 111.1-1.905 1.1 1.1 0 01-1.1 1.905zM2.148 21a1.1 1.1 0 101.905 1.1A1.1 1.1 0 002.148 21zM10.55 22.503a1.1 1.1 0 111.1-1.905 1.1 1.1 0 01-1.1 1.905zM13.148 16a1.1 1.1 0 101.905 1.1 1.1 1.1 0 00-1.905-1.1zM12.55 14.503a1.1 1.1 0 111.1-1.905 1.1 1.1 0 01-1.1 1.905zM20.148 17a1.1 1.1 0 101.905 1.1 1.1 1.1 0 00-1.905-1.1zM19.55 21.503a1.1 1.1 0 111.1-1.905 1.1 1.1 0 01-1.1 1.905zM19.148 9a1.1 1.1 0 101.905 1.1A1.1 1.1 0 0019.148 9zM17.55 7.503a1.1 1.1 0 111.1-1.905 1.1 1.1 0 01-1.1 1.905zM19.148 3a1.1 1.1 0 101.905 1.1A1.1 1.1 0 0019.148 3zM7.55 14.503a1.1 1.1 0 111.1-1.905 1.1 1.1 0 01-1.1 1.905z"
                        }),
                        _jsx("path", {
                            d: "M7 4.45a3 3 0 100 6 3 3 0 000-6zm0 2a1 1 0 110 2 1 1 0 010-2zM15 13.45a3 3 0 116 0 3 3 0 01-6 0zm4 0a1 1 0 10-2 0 1 1 0 002 0zM7 15.45a3 3 0 100 6 3 3 0 000-6zm0 2a1 1 0 110 2 1 1 0 010-2z",
                            fillRule: "evenodd",
                            clipRule: "evenodd"
                        })
                    ]
                })
            })
        ]
    });
};
CocktailIcon.isCarinaIcon = true;
export default CocktailIcon;
